import { render, staticRenderFns } from "./PlasiyerTahsilatAnalizDetay.vue?vue&type=template&id=8ec5ebec&scoped=true"
import script from "./PlasiyerTahsilatAnalizDetay.vue?vue&type=script&lang=js"
export * from "./PlasiyerTahsilatAnalizDetay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec5ebec",
  null
  
)

export default component.exports